var Tooltip = require('./base');

Tooltip.Html = require('./html');
Tooltip.Canvas = require('./canvas');
Tooltip.Mini = require('./mini');
module.exports = Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_component@0.3.8@@antv/component/lib/tooltip/index.js
// module id = 340
// module chunks = 0 1 2